<template>
  <div id="layCaDList">
    <div class="left_Title">
      <p>
        <i class="iconfont iconjieguo"></i>
        <span class="aqt_lang_mn titlefont">{{ $t('m.seareturn') +'&nbsp;'+ '(' + total + ')' |U2M }}</span>
      </p>
      <p></p>
    </div>
    <div v-if="!isNo" class="list_Content aqt_no_su" ref="Content_Width">
      <div class="aqt_list_lists_one" v-for="(item,index) in list" :key="index" @click="getDetail(item)">
        <div class="aqt_top ">
          <i class="iconfont iconyuanquan"></i>
        </div>
        <div class="aqt_center">
          <!-- 蒙语标题 -->
          <div class="aqt_title titlefont aqt_lang_mn"
               v-html="U2M(item.titlelang ? item.titlelang.mn ? item.titlelang.mn.trim(): item.titlelang.zh : '')"></div>

          <div class="aqt_zhengzhuang contentfont contentfonts1 aqt_lang_mn">
            {{
              item.name_lang ? item.name_lang.mn ? item.name_lang.mn : item.name_lang.zh : '' | U2M
            }}{{ TitleList[item.type - 1]|U2M }}
          </div>
          <div class="aqt_zhengzhuangTwo contentfont contentfonts1 aqt_lang_mn">
            {{ TitleList[item.type - 1]|U2M }}
          </div>
        </div>
        <div class="aqt_bottom_img">
          <img src="@/assets/images/detail_bottom.png">
        </div>
      </div>
    </div>
    <div class="page">
      <PageMn v-if="!isNo" :total="total" :current="current_page"
              :pageSize="per_page" @getPager="getPager">
        </PageMn>
      <!-- <Page v-if="!isNo" :total="total"  :current="current_page"
            :page-size="per_page"
            @on-change="getPager"/> -->
    </div>
    <div v-if="isNo&&!list.length" class="nomassage">
      <p class="aqt_lang_mn titlefont">{{ $t('m.noData') | U2M }}</p>
    </div>
    <!--    加载动画-->
   <AqtSpin v-if="isSpin"></AqtSpin>
  </div>
</template>
<script>
export default {
  data() {
    return {
      total: 0,
      current_page: 1,
      per_page: 0,
      list: [],
      isNo: false,
      booksSearch: {
        title: '',
        type: 0,//1.书2.期刊3、报刊、4论文
        page: 1,
        per_page: '',
      },
      isSpin: false,
      TitleList: ['(ᠨᠣᠮ)','(ᠰᠡᠳᠬᠦᠯ)','(ᠰᠣᠨᠢᠨ)','(ᠥᠭᠦᠯᠡᠯ)']
    }
  },
  methods: {
    /******************************************
     *
     *分页器
     *
     *****************************************/
    getPager(page) {
      let that = this
      that.list = []
      that.booksSearch.page = page
      that.getList()
    },
    getList() {
      let that = this
      that.list = []
      that.isSpin = true
      //保存用户搜索记录
      if(that.booksSearch.page==1){
        that.$store.commit('SET_PuserSearch', [JSON.stringify(that.booksSearch), that.$route.path, that.$route.meta.title, 8],)
        that.$store.dispatch('getHedcircle')
      }

      that.$httpsencrypt.post(`api/web/v3/directory/lists`, that.booksSearch)
          .then((val) => {
            if (val.code == 200 && val.data.length) {
              that.total = val.pages.total
              that.current_page = val.pages.current_page
              that.per_page = val.pages.per_page * 1

              if (that.booksSearch.title) {
                val.data.forEach((item) => {
                  var arr = item.titlelang.mn.split(" ");
                  arr.forEach((elem, index) => {
                    var strarr = that.booksSearch.title.split(' ')
                    strarr.forEach(it => {
                      if (it == '') {
                        return
                      }
                      var i = elem.indexOf(it.trim());

                      if (i > -1) {
                        var replacestr =
                            '<span style="color:var(--themeColor)!important;">' +
                            arr[index] +
                            "</span>";
                        arr[index] = replacestr;
                      }

                    })
                  });
                  item.titlelang.mn = arr.join(" ");
                });
              }


              that.list = val.data
              that.isSpin = false
              that.isNo = false
            } else {
              that.list = []
              thst.isNo = true
              that.isSpin = false
              that.total = 0
            }

          }).catch(e => {
            that.list = []
            that.isNo = true
            that.isSpin = false
            that.total = 0
          }
      )
    },
    getDetail(item) {
      let that = this
      that.$Message.warning(that.$t('m.no_permission'));
      return
      if (item.type == 1) {
        let cond = {
          id:item.book_id,
          directory_id:item.directory_id
        }
        that.$emit('getToDeatils',cond,'BookDetails')
      } else if (item.type == 2) {
        let cond = {
          id:item.book_id,
          directory_id:item.directory_id
        }
        that.$emit('getToDeatils',cond,'JournalDetails')

      } else if (item.type == 3) {
        let cond = {
          id:item.book_id,
          directory_id:item.directory_id
        }
        that.$emit('getToDeatils',cond,'NewspapersDetais')
      }

    },

    //父组件调用请求数组
    ParentCom(val){
      let that = this
      that.isNo = false
      that.booksSearch.title=val.title
      that.booksSearch.type=val.type
      that.getList()
    },
  },

  created() {
    let info={
      type: 12,
      path: this.$route.path,
      mark: '目录数据库列表',
    }
    this.$store.dispatch('saveUserBehavior', info).then(() => {
    })
  },
  mounted() {
    let that = this
    let kk = that.$refs.Content_Width.clientWidth / 61.2
    that.booksSearch.per_page = Math.floor(kk)
    that.booksSearch.page =1
  },

}
</script>
<style lang="less" scoped>
#layCaDList {
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;

  .contentfonts1 {
    font-size: 1.6rem;
  }

  .nomassage {
    padding: 0 1rem;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-pack: center;
    display: -ms-flexbox;
    display: flex;
    font-size: 2rem;
  }

  .left_Title {
    width: 54px;
    height: 100%;
    background: #ffffff;
    margin-right: 2px;
    padding-top: 27px;
    display: flex;
    justify-content: flex-end;

    p:nth-child(1) {
      width: 24px;
      color: var(--themeColor);
      font-size: 20px;
      line-height: 24px;

      i {
        font-size: 24px;

      }
    }

    p:nth-child(2) {
      width: 8px;
      height: 162px;
      background: var(--themeColor);
      margin-left: 10px;
    }
  }

  .list_Content {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    overflow-x: auto !important;
    overflow-y: hidden;

    .aqt_list_lists_one {
      width: 61px;
      height: 100%;
      background-color: #ffffff;
      margin-right: 0.2rem;
      //cursor: pointer;
      padding: 0 8px;

      .aqt_top {
        height: 40px;
        width: 4.5rem;
        text-align: center;
        line-height: 62px;

        i {
          font-size: 20px;
          color: var(--themeColor);
        }
      }

      .aqt_center {
        height: calc(100% - 58px);
        width: 4.5rem;
        padding-top: 1rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        overflow: hidden;

        .aqt_lang_mn1 {
          writing-mode: vertical-lr;
        }

        .aqt_title {
          height: 55vh;
          color: #888888;
          font-size: 1.8rem;
          overflow: hidden;
          white-space: pre-line;
          overflow: hidden;
          margin: 0 auto;
          line-height: 22.5px;
        }

        .aqt_zhengzhuang {
          height: 32vh;
          color: #888888;
          font-size: 1.6rem;
          line-height: 22.5px;
          overflow: hidden;
          white-space: pre-line;
          padding: 8px 0;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin: 0 auto;

        }

        .aqt_zhengzhuangTwo {
          height: 13vh;
          color: #888888;
          font-size: 1.6rem;
          line-height: 22.5px;
          overflow: hidden;
          white-space: pre-line;
          padding: 8px 0;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          margin: 0 auto;
        }
      }

      .aqt_bottom_img {
        width: 100%;
        height: 20px;

        img {
          width: 100%;
          height: auto;
        }
      }
    }

    .aqt_list_lists_one:hover {
      background: rgba(255, 255, 255, 0.3);

      .aqt_title {
        color: var(--themeColor);
      }

      .aqt_zhengzhuang {
        color: var(--themeColor);
      }

      .aqt_zhengzhuangTwo {
        color: var(--themeColor);
      }
    }
  }

  .list_Content::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 8px;
  }

  .list_Content::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }

  .list_Content::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }

  .page {
    width: 50px;
    height: 100%;
  }
}
</style>

